(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ReactDOM"), require("React"), require("grapesjs"));
	else if(typeof define === 'function' && define.amd)
		define(["ReactDOM", "React", "grapesjs"], factory);
	else if(typeof exports === 'object')
		exports["vanillaComponentsGrapesjs"] = factory(require("ReactDOM"), require("React"), require("grapesjs"));
	else
		root["vanillaComponentsGrapesjs"] = factory(root["ReactDOM"], root["React"], root["grapesjs"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__4__) {
return 